<div class="a00200">
    <input
        type="text"
        [name]="inputName"
        [id]="inputName"
        [placeholder]="placeholder"
        [formControl]="inputControl"
    />
    <label
        for="{{ inputName }}"
        [inlineSVG]="
            '/assets/icons/details.svg' | assetPath
        "
    ></label>
</div>
